import React from 'react'

const UserCardSvg = ({ width }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      viewBox='0 0 17.065 13.273'
    >
      <path
        id='id-card-svgrepo-com_3_'
        data-name='id-card-svgrepo-com (3)'
        d='M15.643,32H1.422A1.422,1.422,0,0,0,0,33.422V33.9H17.065v-.474A1.422,1.422,0,0,0,15.643,32ZM0,43.851a1.422,1.422,0,0,0,1.422,1.422H15.643a1.422,1.422,0,0,0,1.422-1.422V34.844H0Zm10.429-6.874a.238.238,0,0,1,.237-.237h4.266a.238.238,0,0,1,.237.237v.474a.238.238,0,0,1-.237.237H10.666a.238.238,0,0,1-.237-.237Zm0,1.9a.238.238,0,0,1,.237-.237h4.266a.238.238,0,0,1,.237.237v.474a.238.238,0,0,1-.237.237H10.666a.238.238,0,0,1-.237-.237Zm0,1.9a.238.238,0,0,1,.237-.237h4.266a.238.238,0,0,1,.237.237v.474a.238.238,0,0,1-.237.237H10.666a.238.238,0,0,1-.237-.237ZM5.214,36.74a1.9,1.9,0,1,1-1.9,1.9A1.9,1.9,0,0,1,5.214,36.74ZM1.988,42.79a1.9,1.9,0,0,1,1.8-1.31h.243a3.052,3.052,0,0,0,2.358,0h.243a1.9,1.9,0,0,1,1.8,1.31.467.467,0,0,1-.462.587H2.45A.468.468,0,0,1,1.988,42.79Z'
        transform='translate(0 -32)'
        fill='#b5ccc2'
      />
    </svg>
  )
}

export default UserCardSvg
